export default __webpack_public_path__ + "static/media/jquery.a7204256.svg";